import request from '@/utils/request'
import qs from 'qs'

export const getNewsList = (data: any) =>
  request({
    url: '/news/list',
    method: 'get',
    params: data
  })

export const getNewsCate = () =>
  request({
    url: '/news/category',
    method: 'get'
  })

export const manageList = () =>
  request({
    url: '/news/categoryManageList',
    method: 'get'
  })

export const getNewsDetail = (data: any) =>
  request({
    url: '/news/edit',
    method: 'get',
    params: data
  })

export const getNewsTags = (data: any) =>
  request({
    url: '/news/tagManageList',
    method: 'get',
    params: data
  })

export const editNews = (data: any) =>
  request({
    url: '/news/option',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })

export const addEditTags = (data: any) =>
  request({
    url: '/news/saveTag',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })

export const taggingNews = (data: any) =>
  request({
    url: '/news/taggingNews',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })

/* ************************** 新版文章接口 **************************** */

export const getArticleList = (params: any) =>
  request({
    url: '/article/list',
    method: 'get',
    params
  })

export const getArticleCategory = () =>
  request({
    url: '/article/category',
    method: 'get'
  })

export const getArticleTagList = () =>
  request({
    url: '/article/tagList',
    method: 'get'
  })

export const editCategory = (data: any) =>
  request({
    url: '/article/saveCategory',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })

export const editTag = (data: any) =>
  request({
    url: '/article/saveTag',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })

export const getCategoryData = () =>
  request({
    url: '/article/categoryManageList',
    method: 'get'
  })

export const getTagData = () =>
  request({
    url: '/article/tagManageList',
    method: 'get'
  })

export const getArticleData = (params: any) =>
  request({
    url: '/article/edit',
    method: 'get',
    params
  })

export const deleteArticle = (data: any) =>
  request({
    url: '/article/delete',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })

export const editArticle = (data: any) =>
  request({
    url: '/article/option',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })

export const toppingArticle = (data: any) =>
  request({
    url: '/article/toppingArticle',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })

export const deleteCategory = (data: any) =>
  request({
    url: '/article/deleteCategory',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })

export const deleteTag = (data: any) =>
  request({
    url: '/article/deleteTag',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })
